import { Auth } from "aws-amplify";

import { each, find, get, head, set } from "lodash";

import {
  getCognitoUserId,
  getCognitoUserJwt
} from "../../../../state/selectors/user";

import { evalVersion } from "./version";
import generateGraph from "./graph";

import { createResponse, getPayload, getUserResponses, getUserHistory } from "./api";

const execAuthenticatedFlow = async (
  survey,
  metadata,
  locale,
  branchName
) => {
  const cognitoUser = await Auth.currentAuthenticatedUser();

  const surveyId = get(survey, "_id");
  const userId = getCognitoUserId(cognitoUser);
  const jwtToken = getCognitoUserJwt(cognitoUser);

  const historyResponse = await getUserHistory(surveyId, userId, jwtToken);
  // console.log(historyResponse);

  const history = {};
  each(historyResponse, entry => set(history, entry.name, entry));

  const context = { metadata: { ...metadata, locale, authenticated: true }, history };
  let version = evalVersion(survey, branchName, context);

  if (version === undefined) {
    throw new Error("The specified version does not exist");
  }

  const versionObj = find(get(survey, 'versions', []), { name: version.name });

  // Create graph from blocks sequence
  const graph = generateGraph(survey, versionObj);

  // Fetch user responses
  let userResponses = await getUserResponses(
    surveyId,
    userId,
    jwtToken
  );

  let responseId = null;
  let payload = {};

  // Handle the flow of empty responses
  if (userResponses.length === 0) {
    const response = await createResponse(
      surveyId,
      userId,
      locale,
      { graph, version: version.name },
      metadata,
      jwtToken
    );

    responseId = get(response, "id", null);
    payload = await getPayload(surveyId, userId, responseId, jwtToken);
  } else {
    // Authenticated user is always assumed to have a single response
    const response = head(userResponses);

    responseId = get(response, "_id", null);
    payload = await getPayload(surveyId, userId, responseId, jwtToken);
    // If response exists then use the version the response was created with
    version = find(get(survey, 'versions', []), { name: get(response, 'version') });
  }

  return { responseId, history, payload, version, user: { userId, jwtToken } };
};

export default execAuthenticatedFlow;
